import {FunctionComponent} from "react";
import styles from "./loading.module.css";
import React from "react";
import {connect} from "react-redux";
import {IApplicationState} from "../../../store";
import {LoadingIndicator} from "./LoadingIndicator";
import {iif} from "../iif";
import {Dispatch} from "redux";
import {showDialog} from "../../../store/dialog-manager/actions";
import getFontSize from "../../utils/getFontSize";
import {loadScene} from "../../../store/routing/actions";
import i18n from "../../i18n";

interface LoadingScreenProps {
    isLoading: boolean;
    isError?: boolean;
    showCredits?: () => void;
    gotoMainMenu?: () => void;
}

const renderContent = (props: LoadingScreenProps) => {
    const {isError} = props;

    if (isError !== true) {
        return (<div className={styles.loading_text}>{i18n("loadingcover.header")}</div>);
    }

    const fontSize = getFontSize(i18n("loadingcover.failed").length, 36, 50, 10, 30);

    return (
        <>
            <div className={styles.loading_text} style={{fontSize}}>{i18n("loadingcover.failed")}</div>
            <div className={styles.loading_text} style={{fontSize}}>{i18n("loadingcover.failed.text")}</div>

            {iif(!!props.gotoMainMenu,
                <div className={styles.action_container}>
                    <button onClick={props.gotoMainMenu} className={styles.action}>{i18n("gameplay.menu.continuebutton")}</button>
                </div>
            )}
        </>
    );
};

export const LoadingScreenComponent: FunctionComponent<LoadingScreenProps> = (props) => {
    const {isLoading, isError} = props;

    if (!isLoading && !isError)
        return <></>;

    return (
        <section className={styles.container}>
            {iif(!!props.showCredits,
                <i className={styles.icon_credits} onClick={() => props.showCredits!()}/>
            )}

            <figure className={`${styles.logo} logo`}/>
            <div className={styles.caption}>{i18n("mainmenu.header")}</div>
            <div className={styles.loading_indicator_container}>
                <LoadingIndicator disabled={isError === true}/>
            </div>
            {renderContent(props)}
        </section>
    )
};

export default connect(({ settings, routing }: IApplicationState) => ({
    isError: routing.isError,
    isLoading: routing.isLoading || !routing.scene
}), (dispatch: Dispatch) => ({
    showCredits: () => dispatch(showDialog({
        type: "CreditsDialog",
        options: {
            zIndex: 10001
        }
    })),
    gotoMainMenu: () => dispatch(loadScene.request('MainMenu'))
}))(LoadingScreenComponent);